import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router'
import { withProtectionAndRedirection } from '../../components/LicenseProtected'
import { licenseTypes } from '../../services/FW5ML/parsers/UserParser'
import RiverPage from './RiverPage'
import MyReports from '../myReports/MyReportsPage'
import { siteName } from 'src/utils/oneCodeBase'
import { LIBRARIAN_TYPES } from 'src/constants'
import { getRiverArgs, getRiverKey } from './RiverSelector'
import { riverKeys, PAGES_WITH_NO_PREFIX } from './RiverConstants'
import usePiwik from 'src/hooks/usePiwik'

const RiverRoutes = () => {
  const riverKey = useSelector(getRiverKey)
  const riverArgs = useSelector(getRiverArgs)
  const { handleTracking } = usePiwik()

  const trackRiverPageView = () => {
    if (!location.pathname.match(/^\/(river|stories)\/([^/]+)/)) {
      return
    }
    let decodedPath = decodeURIComponent(riverArgs)

    // PIWIK TRACKING
    let trackingName =
      decodedPath && decodedPath !== 'undefined' ? decodedPath : riverKey

    const prefix = !PAGES_WITH_NO_PREFIX.includes(location.pathname)
      ? 'content-river_'
      : ''

    let pageViewName = `${prefix}${trackingName}`

    // Specific tracking validations
    if (riverKey === riverKeys.EVENTS) {
      pageViewName = riverKey
    }

    handleTracking('page', 'view', pageViewName)
  }

  useEffect(() => {
    trackRiverPageView()
  }, [riverKey, riverArgs])

  return (
    <Switch>
      {/* Main routes */}
      <Route
        exact
        path="/river/:key(my-fw)/:args*"
        component={withProtectionAndRedirection(
          withProtectionAndRedirection(RiverPage, {
            showFor: {
              license: licenseTypes.LICENSE_PLUS,
              paywall: 'plus_only',
              subtype: 'my_fw_stories'
            }
          }),
          {
            showFor: {
              authenticated: true,
              license: licenseTypes.LICENSE_PLUS,
              paywall: 'plus_only',
              subtype: 'my_fw_stories'
            },
            redirectForOthers: '/'
          }
        )}
      />

      <Route
        exact
        path="/river/:key(your-reports)/:args*"
        component={MyReports}
      />
      {siteName !== 'Reports' && (
        <Route
          exact
          path="/river/:key(library-picks)/:args*"
          component={withProtectionAndRedirection(RiverPage, {
            showFor: {
              requireAll: true,
              authenticated: true,
              licenseType: [LIBRARIAN_TYPES.ADMIN, LIBRARIAN_TYPES.USER]
            },
            redirectForOthers: '/sign-in'
          })}
        />
      )}

      <Route
        exact
        path="/river/:key(story-watch|events|resources)/:args*"
        component={RiverPage}
      />
      <Route
        exact
        path="/river/:key(top-stories|iav|conference-news|related-news|related-analysis|tag|type|recent|all-reports|upcoming)/:args*"
        component={RiverPage}
      />

      {/* Search */}
      <Route exact path="/search" component={RiverPage} />
      <Route exact path="/search/:key/:args*" component={RiverPage} />

      {/* Redirect any legacy route */}
      <Redirect
        exact
        from="/stories/:key/:args*"
        to={`/river/:key/:args*${window.location.search}`}
      />

      {/* Defaults */}
      <Route exact path="/river/:key/:args*" component={RiverPage} />
    </Switch>
  )
}

export default RiverRoutes
